module.exports = __webpack_public_path__ + "img/k03.652ef5dc.png";